/**
 * A station just wrote something a sewer's phone shows (a despatch slip, a receipt, a QC pass).
 * Stations call notifyPortalStale(); the auto-publisher, if this browser switched it on, listens.
 * No imports, so a service can call it without pulling the portal into its bundle.
 */
const listeners = new Set<() => void>();

export const notifyPortalStale = (): void => { listeners.forEach((l) => { try { l(); } catch { /* a listener must never break a station write */ } }); };
export const onPortalStale = (l: () => void): (() => void) => { listeners.add(l); return () => { listeners.delete(l); }; };
